import {
  useTableFilter, useTableServerSideFiltering,
  TABLE_CONSTANTS, useLoaders,
  useTableColumnsPreventa, EstadoPreventaEnum,
  gridSizeMdLg6,
  ModulosEnumChoice
} from "@/shared";
// import { useFetchPostFactibilidadCorporativo } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { CustomAutocomplete, CustomTextArea, CustomTextFieldNoForm, GeneralTable } from "@/shared/components/ui";
import { Grid, IconButton, Tooltip } from "@mui/material";
import PendingIcon from '@mui/icons-material/Pending';
import { useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
// import { usePostPlanCorporativo } from "@/shared/actions/erp/planes";
import { fetchGetPreventasCorporativos, fetchPutPreventaCorporativo } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import { IPreventaCorporativo } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { MotivoRechazo } from "@/shared/interfaces";
import { useFetchMotivosRechazo } from "@/shared/actions/erp";
import { useForm } from "react-hook-form";
import { ModalMotivoForm, newModalMotivoFormaSchema } from "@/shared/utils/validation-schemas/erp/ventas/preventa/preventa_corporativo.schema";
import { yupResolver } from "@hookform/resolvers/yup";

export default function TableSolicitudCapacidadCorporativo() {

  const [open, setOpen] = useState(false);
  const [modalCancelar, setModalCancelar] = useState(false);
  const [dataSolicitud, setDataSolicitud] = useState<IPreventaCorporativo | null>(null);


  // ===========================================================================
  // forms
  // ===========================================================================
  const formRechazo = useForm<ModalMotivoForm>({
    resolver: yupResolver(newModalMotivoFormaSchema),
  });

  ///* Hook
  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;
  const { columnsPreventaCorporativo } = useTableColumnsPreventa(EstadoPreventaEnum.EN_ESPERA);


  ///* Fetch

  const {
    isLoading,
    data: preventasRes,
    isRefetching
  } = fetchGetPreventasCorporativos(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      estado_preventa: EstadoPreventaEnum.PREAPROBADA,
      plan_personalizado: true,
      aprueba_plan_personalizado: false,
      condicion_venta_isnull_or_void: true,
      

    }
  );

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo(
    {
      estado: true,
      modulo: ModulosEnumChoice.FACTIBILIDAD_CORPORATIVO,
      page_size: 100,
    },
    modalCancelar
  );

  //const { mutateAsync: mutateAsyncFactCorp, isPending } = useFetchPostFactibilidadCorporativo({})

  const {
    mutateAsync: mutateAsyncPutPreventaCorporativo, isPending
  } = fetchPutPreventaCorporativo({})

  // const {
  //   mutateAsync: mutateAsyncPostPlanCorporativo
  // } = usePostPlanCorporativo({})

  useLoaders(isPending)

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaCorporativo>
            columns={columnsPreventaCorporativo}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            enableEditing={true}
            showCustomActionBtnSpace={true}

            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    <Grid item >
                      <Tooltip placement='top' title='Ver Factibilidad Corporativa'>
                        <IconButton
                          onClick={() => {

                            console.log(value.data_plan_personalizado);

                            setOpen(true)
                            setDataSolicitud(value)
                          }}
                        >
                          <PendingIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

      {
        open && (
          <ScrollableDialogProps
            open={open}
            title={`Solicitud Enlace`}
            width="69%"
            onClose={() => {
              setOpen(false)
              setDataSolicitud(null);
            }}
            onConfirm={async () => {

              if (dataSolicitud) {


                // const respPlan = await mutateAsyncPostPlanCorporativo({
                //   plan_personalizado: true,
                //   nombre: dataSolicitud.data_plan_personalizado?.nombre_personalizado!,
                //   tipo_plan: dataSolicitud.data_plan_personalizado?.tipo_plan_personalizado!,
                //   permanencia: dataSolicitud.data_plan_personalizado?.permanencia_personalizado!,
                //   costo_instalacion: dataSolicitud.data_plan_personalizado?.costo_instalacion_personalizado!,
                //   valor: dataSolicitud.data_plan_personalizado?.valor_personalizado!,
                //   capacidad: parseFloat(dataSolicitud.data_plan_personalizado?.capacidad_personalizado!),
                // })

                // if (respPlan.code == 200) {
                  await mutateAsyncPutPreventaCorporativo({
                    id_preventa_coorporativa: dataSolicitud.id_preventa_coorporativa,
                    aprueba_plan_personalizado: true,
                    // plan: respPlan.data.codigo
                  })
                // }
              }

              setOpen(false);
              setDataSolicitud(null);

            }}
            confirmVariantBtn='contained'

            ///* rechazar
            onReject={async () => {
              setOpen(false)
              setModalCancelar(true);

            }}
            showRejectBtn={true}
            contentNode={
              <>
                <Grid item xs={12} container spacing={3} alignItems="center">

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={'Nombre personalizado'}
                    value={dataSolicitud?.data_plan_personalizado?.nombre_personalizado ?? 'N/A'}
                    shrink={true}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={'Tipo plan personalizado'}
                    value={dataSolicitud?.data_plan_personalizado?.tipo_plan_personalizado ?? 'N/A'}
                    shrink={true}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={'Permanencia personalizado'}
                    value={dataSolicitud?.data_plan_personalizado?.permanencia_personalizado ?? 'N/A'}
                    shrink={true}
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={'Costo instalacion personalizado'}
                    value={dataSolicitud?.data_plan_personalizado?.costo_instalacion_personalizado ?? 'N/A'}
                    shrink={true}
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={'Valor personalizado'}
                    value={dataSolicitud?.data_plan_personalizado?.valor_personalizado ?? 'N/A'}
                    shrink={true}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={'Enlace personalizado'}
                    value={dataSolicitud?.data_plan_personalizado?.capacidad_personalizado ?? 'N/A'}
                    shrink={true}
                    size={gridSizeMdLg6}
                  />

                  {/* <Grid item {...gridSizeMdLg12}>
                    <Typography>
                      {`Una vez que confirmes la capacidad, el cambio será aceptado y no se podrá revertir. ¿Estás seguro de que deseas continuar? `}
                    </Typography>
                  </Grid> */}


                </Grid>
              </>
            }
          />
        )
      }





      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás por rechazar una factibilidad corporativa. ¿Estás seguro este cambio es irreversible?`}
          contentNode={
            <Grid container spacing={3}>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ""}
                isLoadingData={
                  isLoadingMotivosRechazo || isRefetchingMotivosRechazo
                }
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={
                  !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
                  "El motivo de rechazo es requerido"
                }
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_motivo_rechazo"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={
                  formRechazo.getValues().observacion_motivo_rechazo ?? ""
                }
                error={formRechazo.formState.errors.observacion_motivo_rechazo}
                helperText={
                  formRechazo.formState.errors.observacion_motivo_rechazo
                    ?.message
                }
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async (_form) => {
            const resp = await mutateAsyncPutPreventaCorporativo({
              id_preventa_coorporativa: dataSolicitud!.id_preventa_coorporativa,
              estado_preventa: EstadoPreventaEnum.CANCELADO,
              observacion_rechazo: [
                {
                  motivo: formRechazo.getValues().observacion_motivo_rechazo,
                  observacion:formRechazo.getValues().motivo_rechazo,
                  fecha:(new Date()).toISOString()
                }
              ]
            });

            resp.code == 200 && setModalCancelar(false);
            setDataSolicitud(null);
          })}
          onClose={() => {
            setModalCancelar(false);

            setDataSolicitud(null);
          }}
        />
      )}



    </>
  );

}